import { useEffect, useState } from 'react';

const useCancelModal = () => {
  const [showCancelModal, setShowCancelModal] = useState(false);

  useEffect(() => {
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  const openCancelModal = () => {
    document.body.classList.add('modal-open');
    setShowCancelModal(true);
  };

  const closeCancelModal = () => {
    document.body.classList.remove('modal-open');
    setShowCancelModal(false);
  };

  return { showCancelModal, openCancelModal, closeCancelModal };
};

export default useCancelModal;
